























import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { ISort } from '@/entities/sort.interface';

@Component({})
export default class ThSortableComponent extends Vue {
    @Prop() public current: ISort;

    @Prop() public field: string;

    public asc: boolean = this.current.asc;

    public toggle() {
        if (this.field !== this.current.field) {
            this.asc = true;
        } else {
            this.asc = !this.asc;
        }

        this.change({
            field: this.field,
            asc: this.asc
        });
    }

    @Emit()
    public change(sort: ISort) {
        // emit
    }
}
